import React from 'react'
import DobitniciContent from '../components/DobitniciContent_SI'
import mainContentPrizes from '../assets/img/slo_nagrada_2026-opt.png'

const MainContent_SI = () => {

  return (
    <div>
      <article className="mainContent pb-8">
        <div className="px-2 lg:px-14">
          <h1 className="font-bold text-3xl sm:text-4xl lg:text-5xl mb-8 lg:mb-10">Dr. Oetker tudi to pomlad nagrajuje!</h1>
          <h2 className="font-bold text-xl sm:text-2xl lg:text-3xl max-w-[60ch] mx-auto mb-8 lg:mb-10">Sodelujte v LOVU NA PIRHE in osvojite eno izmed kar 20 privlačnih nagrad!</h2>
          <p>Prazniki že trkajo na vrata – čas sladkih razvajanj, omamnih vonjav iz kuhinje in toplih trenutkov, ki nas povežejo ob skupni mizi. Da bi bile vaše praznične priprave še bolj zabavne in navdihujoče, smo pripravili novo nagradno igro, polno sladkih presenečenj.</p>
          <p><strong>V času trajanja nagradne igre <strong>od 16. 3. do 4. 4. 2026</strong> bomo podarili:</strong></p>
          <br />
          <p><strong>10 Dr. Oetker darilnih paketov,</strong></p>
          <p><strong>10 cvrtnikov na vroč zrak.</strong></p>
          
        </div>
      </article>
      <div style={{ backgroundColor: '#fedf54' }}>
          <div className="flex justify-center">
            <img className="mainContentPrizes" src={mainContentPrizes} alt="nagrada" />
          </div>
      </div>
      <article className="mainContent pt-12 pb-4">
        <div className="px-2 lg:px-16">
          <p><strong>Kako sodelovati?</strong></p>
          <p>Velikonočni zajček je bil letos malo nagajiv … skril je 10 pirhov, vendar niso vsi polni presenečenj! Na spodnji fotografiji poiščite vse skrite pirhe. A pozor, čeprav jih je deset, le nekateri skrivajo nagrado, medtem ko so drugi prazni.</p>
          <p>Poiščite pirhe in preizkusite svojo srečo!</p>
          <p>Ko opravite nalogo, izpolnite spodnji prijavni obrazec in sodelujte v nagradni igri.</p>
          <br />
          <p>Srečno!</p>
        </div>
      
      </article>
    </div>
  )

}

export default MainContent_SI